export const ReportTypes = {
  PrecheckEnquiryReport: { reportTypeId: 10 },
  CreditEnquiryReport: { reportTypeId: 1 },
  CIPCBusinessReport: { reportTypeId: 2 },
  CIPCDirectorEnquiryReport: { reportTypeId: 3 },
  RealTimeIDVReport: { reportTypeId: 4 },
  DetailedBusinessReport: { reportTypeId: 5 },
  FaceViewReport: { reportTypeId: 6 },
  SanctionScreeningReport: { reportTypeId: 7 },
  WorldComplianceReport: { reportTypeId: 8 },
  ConsumerTraceReport: { reportTypeId: 9 },
  SpiderSearchCompany: { reportTypeId: 11 },
  SpiderSearchConsumer: { reportTypeId: 12 },
  SpiderSearchTrust: { reportTypeId: 13 },
  BankVerificationSearchCompany: { reportTypeId: 14 },
  BankVerificationSearchConsumer: { reportTypeId: 15 },
  BankVerificationSearch: { reportTypeId: 16 },
}

export const ProductIds = {
  CreditEnquiryReport: { productId: 15 },
  XpertBusinessReport: { productId: 12 },
  DirectorEnquiry: { productId: 14 },
  RealTimeIDV: { productId: 153 },
  DetailedBusinessReport: { productId: 41 },
  FaceViewReport: { productId: 234 },
  SanctionScreeningReport: { productId: 176 },
  WorldComplianceReport: { productId: 177 },
  ConsumerTraceReport: { productId: 2 },
  SpiderSearchCompany: { productId: 178 },
  SpiderSearchConsumer: { productId: 179 },
  SpiderSearchTrust: { productId: 180 },
  BankVerificationSearchCompany: { productId: 199 },
  BankVerificationSearchConsumer: { productId: 200 },
  BankVerificationSearchTrust: { productId: 201 },
}

export const SpiderSearchTypes = {
  PERSON: 1,
  TRUST: 2,
  COMPANY: 3,
}

export const OwnerEnquirySearchTypes = {
  PERSON: 1,
  TRUST: 2,
  COMPANY: 3,
}

export const BankAccountVerificationSearchTypes = {
  PERSON: 1,
  TRUST: 2,
  COMPANY: 3,
}
